export { default, qrHashes } from './QRModal'
export type { Props } from './QRModal'
